import { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';

const AGE_GATE_KEY = 'icg_age_verified';

const AgeGate = ({ onVerified }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const verified = localStorage.getItem(AGE_GATE_KEY);
      if (!verified) {
        setVisible(true);
        // Prevent background scroll
        document.body.style.overflow = 'hidden';
      } else {
        onVerified && onVerified();
      }
    } catch (e) {
      setVisible(true);
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleEnter = () => {
    try { localStorage.setItem(AGE_GATE_KEY, '1'); } catch (e) {}
    document.body.style.overflow = '';
    setVisible(false);
    onVerified && onVerified();
  };

  const handleExit = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 99999,
        bgcolor: 'rgba(0,0,0,0.97)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
        textAlign: 'center',
      }}
    >
      {/* Logo / Brand */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 800,
            color: '#fff',
            letterSpacing: 1,
            fontFamily: 'inherit',
          }}
        >
          Insta<span style={{ color: '#e91e63' }}>Cam</span>Girls
        </Typography>
        <Typography sx={{ color: '#aaa', fontSize: 13, mt: 0.5 }}>
          instacamgirls.com
        </Typography>
      </Box>

      {/* Warning badge */}
      <Box
        sx={{
          bgcolor: '#e91e63',
          color: '#fff',
          fontWeight: 700,
          fontSize: 11,
          letterSpacing: 2,
          px: 2,
          py: 0.5,
          borderRadius: 1,
          mb: 3,
          textTransform: 'uppercase',
        }}
      >
        Adults Only — 18+
      </Box>

      {/* Main message */}
      <Typography
        variant="h5"
        sx={{ color: '#fff', fontWeight: 700, mb: 1.5, maxWidth: 440 }}
      >
        This website contains adult content
      </Typography>
      <Typography
        sx={{ color: '#bbb', fontSize: 14, mb: 4, maxWidth: 420, lineHeight: 1.6 }}
      >
        By entering, you confirm that you are <strong style={{ color: '#fff' }}>18 years of age or older</strong>,
        that adult content is legal in your jurisdiction, and that you agree to our{' '}
        <a href="/terms" style={{ color: '#e91e63', textDecoration: 'none' }}>Terms of Service</a>.
      </Typography>

      {/* CTA Buttons */}
      <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' }, width: '100%', maxWidth: 380 }}>
        <Button
          fullWidth
          variant="contained"
          size="large"
          onClick={handleEnter}
          sx={{
            bgcolor: '#e91e63',
            color: '#fff',
            fontWeight: 700,
            fontSize: 15,
            py: 1.5,
            borderRadius: 2,
            textTransform: 'none',
            '&:hover': { bgcolor: '#c2185b' },
          }}
        >
          I am 18+ — Enter
        </Button>
        <Button
          fullWidth
          variant="outlined"
          size="large"
          onClick={handleExit}
          sx={{
            borderColor: '#555',
            color: '#aaa',
            fontWeight: 600,
            fontSize: 14,
            py: 1.5,
            borderRadius: 2,
            textTransform: 'none',
            '&:hover': { borderColor: '#777', color: '#ccc', bgcolor: 'transparent' },
          }}
        >
          I am under 18 — Exit
        </Button>
      </Box>

      {/* Legal footer */}
      <Typography sx={{ color: '#555', fontSize: 11, mt: 4, maxWidth: 420 }}>
        All performers on this site are 18 years of age or older. 18 U.S.C. 2257 Record-Keeping
        Requirements Compliance Statement available upon request.
      </Typography>
    </Box>
  );
};

export default AgeGate;
